import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";

const ProtectedRoutes = ({ component: Component, ...rest }) => {
  const { uid, user } = useSelector((state) => state.auth);

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!uid || !user) {
          return <Redirect to="/auth/login" />;
        }

        const { type } = user;

        if (rest.path.startsWith("/admin") && type === "admin") {
          return <Redirect to="/super-admin" />;
        }

        if (rest.path.startsWith("/super-admin") && type !== "admin") {
          return <Redirect to="/admin" />;
        }

        return <Component {...props} />;
      }}
    />
  );
};

export default ProtectedRoutes;
